// EP-135 Tier 3 — Customer-facing meeting + ballot strings.
// EP-135 Tier 4 — Customer-side read-only minutes (certified only).
export default {
  title: 'Meetings',
  empty_title: 'No meetings yet',
  empty_body:
    'When the operator schedules a meeting and adds you as an attendee (or names you as a proxy), it will appear here.',
  call_n: 'Call {{n}}',
  status: {
    draft: 'Draft',
    noticed: 'Notice issued',
    in_progress: 'In progress',
    voting_closed: 'Voting closed',
    closed: 'Closed',
    certified: 'Certified',
  },
  proxy_role_only: 'You are listed as a proxy',
  proxy_for_one: 'Proxy for {{name}}',
  proxy_for_other: 'Proxy for {{count}} owners',
  join_meeting: 'Join online meeting',
  your_weight: 'Your weight: {{weight}} of quorum',
  resolutions_title: 'Resolutions',
  resolutions_empty: 'No resolutions have been filed for this meeting yet.',
  resolution_seq: 'Resolution {{seq}}',
  secret_ballot: 'Secret ballot',
  you_voted: 'You voted: {{choice}}',
  cast_ballot: 'Cast ballot',
  change_ballot: 'Change ballot',
  cast_for: 'Casting on behalf of',
  attendee_self: 'Myself',
  attendee_proxy: 'Proxy for {{name}}',
  your_choice: 'Your choice',
  submit_ballot: 'Submit ballot',
  choices: {
    for: 'For',
    against: 'Against',
    abstain: 'Abstain',
  },
  minutes: {
    title: 'Minutes',
    view_minutes: 'View signed minutes',
    pending_message:
      'The signed minutes will be available here once both the chair and the secretary have signed.',
    not_yet_certified_title: 'Minutes not yet certified',
    not_yet_certified_body:
      'The signed minutes will be available here once the meeting is fully certified.',
    sections: {
      header: 'Meeting details',
      attendance: 'Attendance',
      resolutions: 'Resolutions',
      certification: 'Certification',
    },
    labels: {
      chair: 'Chair',
      secretary: 'Secretary',
      meeting_type: 'Type',
      call_number: 'Call',
      agenda: 'Agenda',
      notice_lead_days: 'Notice lead (days)',
      presence: 'Status',
      weight: 'Weight',
      secret: 'Secret',
      total_cast: 'Total cast',
      outcome: 'Outcome',
    },
  },
}
